import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SetCanSaveEditOrder } from "../../../../../../Redux/actions/actionNames";

const App = () => {
  const dispatch = useDispatch();

  // ====== معادل mapStateToProps ======
  const price = useSelector((state) => state.NewOrder.newOrder.price);

  const firstDropOff = useSelector(
    (state) => state.EditOrder.editOrder.dropOffs.firstDropOff
  );

  const firstDropOffCustomFields = useSelector(
    (state) =>
      state.EditOrder.editOrder.dropOffs.firstDropOff.customFields || {}
  );

  const deliveryMethodSetting = useSelector(
    (state) => state.ViewTravel.pureData.deliveryMethod?.setting
  );

  // ====== Helpers ======

  const emailValidate = useCallback((email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }, []);

  const firstDropOffRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    let boolly = true;

    firstDropOff?.customFieldDefinitions
      ?.filter((item) => item.stage === "dropoff" && item.isRequired)
      .forEach((item) => {
        if (!firstDropOffCustomFields[item.key]) {
          boolly = false;
        }
      });

    const name = deliveryMethodSetting.isDropoffAddressNameRequired
      ? firstDropOff.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isDropoffAddressPhoneRequired
      ? firstDropOff.phone?.trim()?.length > 0
      : true;

    const email = deliveryMethodSetting.isDropoffAddressEmailRequired
      ? firstDropOff.email &&
        firstDropOff.email.length > 0 &&
        emailValidate(firstDropOff.email)
      : true;

    return name && phone && email && boolly;
  }, [
    deliveryMethodSetting,
    firstDropOff,
    firstDropOffCustomFields,
    emailValidate,
  ]);

  // ====== معادل componentWillReceiveProps ======
  useEffect(() => {
    const canSave = price?.done && firstDropOffRequiredCheck();

    dispatch(SetCanSaveEditOrder(!!canSave));
  }, [price, firstDropOffRequiredCheck, dispatch]);

  return null;
};

export default App;
